import dealService from 'resources/deal/deal.service';
import * as storageService from 'services/storage.service';
import { getTodayIsoDate } from 'utils/date';
import { createTransactionFilePath } from 'resources/document/generateStoragePath';


const uploadImageToTransaction = async ({ imageFile, deal }) => {
  if (!imageFile) {
    return {
      imagePublicUrl: deal.property?.image_url,
    };
  }

  if (deal.property?.image_url) {
    const bucketPath = 'transactions/';
    const path = deal.property.image_url.substr(deal.property.image_url.indexOf(bucketPath) + bucketPath.length);

    await storageService.removeFile({
      bucket: 'transactions',
      path,
    });
  }

  const filePath = createTransactionFilePath({
    companyId: deal.company_id,
    realtorId: deal.realtor_id,
    clientId: deal.client_ids[0],
    fileName: imageFile.name,
  });

  const imagePublicUrl = await storageService.uploadFileAndGetPublicUrl({
    bucket: 'transactions',
    file: imageFile,
    path: filePath,
  });

  return {
    imagePublicUrl,
  };
};

/**
 * Edit transaction details
 * @description For update the status of the transaction just pass the status.
 * If is needed to start the transaction use a dealStatus that is a start status, and the transactionDetails
 * ex: `DEAL_STATUSES.ACTIVE`
 *
 *
 * */
const editTransactionDetails = async ({
  dealId,
  transactionDetails,
  status,
}) => {
  const {
    imageFile, imageUrl, addressLine1, addressLine2, city, state, zip, advancedFields, closingDate, underContractDate,
  } = transactionDetails;

  const deal = await dealService.findById(dealId);

  const {
    property: { address: initialAddress },
    transaction: initialTransaction,
  } = deal;

  const { imagePublicUrl } = await uploadImageToTransaction({ imageFile, deal });

  const property = {
    image_url: imageUrl || imagePublicUrl,
    address: {
      line1: addressLine1 || initialAddress.line1,
      line2: addressLine2 || initialAddress.line2,
      city: city || initialAddress.city,
      state: state || initialAddress.state,
      zip: zip || initialAddress.zip,
    },
  };

  const response = await dealService.updateOne({ id: deal.id }, {
    ...(status && { status }),
    advanced_fields: advancedFields,
    property,
    transaction: {
      ...initialTransaction,
      ...(status && { created_on: getTodayIsoDate() }),
      ...(closingDate && { closing_on: closingDate }),
      ...(underContractDate && { individual_under_contract_date: underContractDate }),
    },
  },
  );

  return response.data[0];
};

export {
  editTransactionDetails,
};
